module.exports = __webpack_public_path__ + "static/Vred-3fa0d66d80928162f6a47a1f80844f0e.png";